import i18n from '../i18n'
import _ from 'lodash'
export const REQUIRED = v => {
    return (!_.isNull(v) && (_.isArrayLikeObject(v) ? !_.isEmpty(v) : !_.isEmpty(`${v}`))) || i18n.t('required')
}
